import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const Grasses: Portfolio = {
    path: "grasses",
    name: "Grasses",
    pageStyle: PageStyle.Tan,
    pieces: [
        {image: "grasses-01.jpg", thumbAlt: "Grasses", title: "Grasses 4", size: "6 \u00d7 24", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-02.jpg", thumbAlt: "Grasses", title: "Grasses 6", size: "6 \u00d7 24", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-03.jpg", thumbAlt: "Grasses", title: "Grasses 10", size: "6 \u00d7 24", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-04.jpg", thumbAlt: "Grasses", title: "Grasses 12", size: "6 \u00d7 24", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-05.jpg", thumbAlt: "Grasses", title: "Grasses 18", size: "6 \u00d7 24", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-06.jpg", thumbAlt: "Grasses", title: "Grasses 19", size: "6 \u00d7 24", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-07.jpg", thumbAlt: "Grasses", title: "Grasses 21", size: "6 \u00d7 24", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-08.jpg", thumbAlt: "Grasses", title: "Grasses 24", size: "6 \u00d7 24", pixelWidth: 175, pixelHeight: 705},
        {image: "grasses-09.jpg", thumbAlt: "Grasses", title: "Grasses 25", size: "6 \u00d7 24", pixelWidth: 175, pixelHeight: 705},
    ],
    piecesColumns: 9,
    piecesTallMode: true,
    statementTitle: "Grasses",
    statement: {
        leftColumn: [
            <>"The rain-drenched stone that leads the way" <i>Santoka</i></>,
            "The natural world and its complexities are the foundation of my art practice. I am mystified, inspired, and humbled by the intricacies of the systems that inform and embody human existence and provide the context in which we live.",
            "The creatures and plants on earth in relationship with humans and their coevolution is a moving, breathing entity. It is a wonder to explore the tender and energetic meeting place where the two intersect. There is a language here in this confluence…a dynamic cry or a soothing whisper…that moves us forward, together. I am inspired by this relationship and its beauty, mystery, and tragedy, but most of all its potential.",
            "Todd McGrain says, \"Forgetting is the last form of extinction.\" Remembering is fundamental to my work. I commemorate my own losses within the ongoing transitions of the natural world.",
        ],
        rightColumn: [],
    },
};

export default Grasses;
